<template>
  <div class="statistics-field-list-editor">
    <draggable class="field-ul" v-model="list" :options="{ handle: '.iconpaixu1' }">
      <div class="field-item" v-for="item in list" :key="item._id">
        <i class="iconfont iconpaixu1"></i>
        <div class="field-item-title single-ellipsis" @click="updHide(item._id, !hideEnum[item._id])">
          <span>{{ item.title }}</span>
        </div>
        <el-checkbox :value="!hideEnum[item._id]" @change="val => updHide(item._id, !val)">
          <span></span>
        </el-checkbox>
      </div>
    </draggable>
    <div class="upd-hide-tools">
      <el-button @click="closeHandle" :disabled="saveLoading">
        <span>取消</span>
      </el-button>
      <el-button type="primary" :loading="saveLoading" @click="confirmHandle">
        <span>确认</span>
      </el-button>
    </div>
  </div>
</template>

<script setup>
import { ref } from 'vue';
import { sortBy } from 'lodash';

import { Message } from 'element-ui';
import draggable from 'vuedraggable';

const emit = defineEmits(['updFieldsHideAndSort', 'close']);
const props = defineProps(['fields', 'hideAndSortInfo']);

// eslint-disable-next-line vue/no-setup-props-destructure
const { sortIds, hideIds } = props.hideAndSortInfo;
const maxSortIdx = sortIds.length > props.fields.length ? sortIds.length : props.fields.length;
const list = ref(
  sortBy(props.fields, fieldDetail => {
    let sortIdx = sortIds.indexOf(fieldDetail._id);

    if (sortIdx === -1) {
      sortIdx = maxSortIdx;
    }

    if (hideIds.includes(fieldDetail._id)) {
      sortIdx = maxSortIdx + 1;
    }

    return sortIdx;
  })
);

const hideEnum = ref({});
props.fields.forEach(fieldDetail => (hideEnum.value[fieldDetail._id] = hideIds.includes(fieldDetail._id)));

const updHide = (fieldId, val) => {
  hideEnum.value = { ...hideEnum.value, [fieldId]: val };
};

const closeHandle = () => {
  emit('close');
};

const saveLoading = ref(false);
const confirmHandle = async () => {
  saveLoading.value = true;

  const showIds = [];
  const newHideIds = [];
  list.value.forEach(fieldDetail => {
    if (hideEnum.value[fieldDetail._id]) {
      newHideIds.push(fieldDetail._id);
    } else {
      showIds.push(fieldDetail._id);
    }
  });

  emit('updFieldsHideAndSort', {
    hideIds: newHideIds,
    sortIds: [...showIds, ...newHideIds],
    callback: success => {
      saveLoading.value = false;
      if (success) {
        closeHandle();
        Message.success('保存成功');
      }
    }
  });
};
</script>

<style lang="scss" scoped>
.statistics-field-list-editor {
  .field-ul {
    max-height: 310px;
    overflow: auto;
    padding: 5px 0;

    &::-webkit-scrollbar {
      display: none;
    }
    .field-item {
      display: flex;
      align-items: center;
      padding: 5px 10px;
      cursor: pointer;

      .iconpaixu1 {
        color: #9599a5;
        font-size: 14px;
        margin-right: 4px;
      }

      .field-item-title {
        flex: 1;
        width: 0;
        color: #2c3443;
        font-size: 14px;
      }
      ::v-deep .el-checkbox__label {
        display: none;
      }
    }
  }

  .upd-hide-tools {
    display: flex;
    padding: 10px;
    border-top: 1px solid #ebeef5;
    .el-button {
      flex: 1;
      width: 0;
      margin-left: 10px;

      &:first-child {
        margin-left: 0;
      }
    }
  }
}
</style>
